import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-enroll-success',
  standalone: true,
  imports: [CommonModule, RouterLink],
  template: `
  <div class="enroll-wrap">
    <div class="card">
      <h2 class="title">¡Registro enviado!</h2>
      <p class="desc">Hemos generado un enlace de validación y lo enviamos al correo del administrador registrado.</p>

      <div class="success">
        <p><strong>Negocio creado correctamente.</strong></p>
        <p><strong>UUID:</strong> {{ businessUuid || '—' }}</p>
        <p><strong>Email administrador:</strong> <code>{{ adminEmail || '—' }}</code></p>
        <p class="hint">Revisa tu bandeja de entrada y sigue el enlace para validar la cuenta antes de iniciar sesión.</p>
        <div class="actions">
          <button class="btn primary" (click)="goToLogin()">Volver al login</button>
          <a routerLink="/" class="btn">Ir al inicio</a>
        </div>
      </div>
    </div>
  </div>
  `,
  styles: [
    `
    .enroll-wrap{display:flex;align-items:center;justify-content:center;min-height:70vh;padding:24px}
    .card{max-width:780px;width:100%;background:#fff;border-radius:12px;box-shadow:0 6px 16px rgba(0,0,0,.08);padding:24px}
    .title{margin:0 0 8px 0;font-size:22px;font-weight:600}
    .desc{margin:0 16px 16px 0;color:#6b7280;font-size:14px}
    .success{margin-top:8px;color:#065f46;background:#d1fae5;border:1px solid #a7f3d0;padding:10px;border-radius:8px}
    .hint{color:#065f46;margin-top:6px}
    .actions{margin-top:16px;display:flex;gap:12px}
    .btn{appearance:none;border:none;border-radius:8px;padding:10px 16px;background:#f3f4f6;color:#111827;font-weight:500;cursor:pointer;text-decoration:none}
    .btn.primary{background:#f26600;color:#fff}
    .btn:hover{filter:brightness(.98)}
    code{background:#f3f4f6;padding:0 4px;border-radius:4px}
    `
  ]
})
export class EnrollSuccessComponent {
  adminEmail = '';
  businessUuid = '';

  constructor(private route: ActivatedRoute) {
    const qp = this.route.snapshot.queryParamMap;
    this.adminEmail = (qp.get('email') || '').toString();
    this.businessUuid = (qp.get('businessUuid') || '').toString();
  }

  goToLogin() {
    window.location.href = '/login';
  }
}